import { pathOr } from 'ramda';

import { INewbuildingOfferDecorationInfoBannerSchema } from '../../../node/repositories/offer-card/entities/newbuilding_offer_decoration/NewbuildingOfferDecorationInfoBannerSchema';
import { IState } from '../../store';

export const getDecorationsBanner = (state: IState): INewbuildingOfferDecorationInfoBannerSchema | null => {
  return pathOr(null, ['offerData', 'decorationInfo', 'banner'], state);
};
